import { Next } from '@securitize/ui-components';

export const GET_ISSUER_AUTHORIZATION_SETTINGS_NEXT = (countryCode, state) =>
// eslint-disable-next-line
  new Next(`/authorization-settings/${countryCode}${state ? `?state=${encodeURI(state)}` : ''}`,
    'GET_ISSUER_AUTHORIZATION_SETTINGS_NEXT');
